import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ProjectForm from "@/components/ProjectForm";

export default function ProjectFormPage() {
  return (
    <div className="min-h-screen bg-dark-slate text-white">
      <Navigation onBookCall={() => {}} />
      
      {/* Hero Section with Form */}
      <section className="min-h-screen flex items-center relative overflow-hidden py-20">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 z-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-cyber-purple rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-drift"></div>
          <div className="absolute top-40 right-10 w-72 h-72 bg-cyber-blue rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-orbit" style={{animationDelay: '2s'}}></div>
          <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-neon-pink rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-spiral" style={{animationDelay: '4s'}}></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <ProjectForm />
        </div>
      </section>



      <Footer />
    </div>
  );
}